
import { mapState } from 'vuex'
import { categoryLoadMoreNum } from '@/utils/constants'

import ProductListingLayout from '@/components/ProductListingLayout'
import ProductTile from '@/components/ProductTile'
import HeroButton from '@/components/HeroButton'
import HeroTabs from '@/components/HeroTabs'

export default {
  jsonld() {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: this.category.breadcrumb?.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id':
            item.link === null
              ? `https://${this.hostUrl}${this.$nuxt.$route.path}`
              : `https://${this.hostUrl}${item.link}`,
          name: item.name,
        },
      })),
    }
  },
  components: {
    ProductTile,
    HeroButton,
    ProductListingLayout,
    HeroTabs,
  },
  asyncData({ req }) {
    return { hostUrl: req?.headers?.host || window.location.host }
  },
  data() {
    return {
      loadedProductsNum: categoryLoadMoreNum,
      tabs: [
        { id: 0, name: this.$t('tabsBrandCategory.productList') },
        { id: 1, name: this.$t('tabsBrandCategory.description') },
      ],
      activeTab: 0,
    }
  },
  async fetch({ store, route, app }) {
    const id = app.$getResourceId(route.name)
    await store.dispatch('category/getCategory', id)
  },
  head() {
    const langMeta =
      this.category?.meta?.lang?.map((lang) => ({
        rel: 'alternate',
        hreflang: lang.code,
        href: lang.url,
      })) || []

    return {
      title: this.category.meta?.title || this.meta?.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.category.meta?.description || this.meta?.description,
        },
      ],
      link: [...langMeta],
    }
  },
  computed: {
    ...mapState(['category', 'meta']),
    canLoadMore() {
      return this.loadedProductsNum < this.category.products.length
    },
    loadMoreText() {
      const productsLeft = this.category.products.length - this.loadedProductsNum
      const loadMore = productsLeft < categoryLoadMoreNum ? productsLeft : categoryLoadMoreNum

      return this.$t('category.loadMore', { count: loadMore })
    },
  },
  methods: {
    changeTab(index) {
      this.activeTab = index
    },
    loadMoreProducts() {
      this.loadedProductsNum += categoryLoadMoreNum
    },
  },
}
